/** Returns true when the props are of type {@link DayPickerSingleProps}. */
export function isDayPickerSingle(props) {
    return props.mode === 'single';
}
//# sourceMappingURL=DayPickerSingle.js.map